import { Component, OnInit } from '@angular/core';
import { ProduitService } from '../_services/Produit.service';
import * as Highcharts from 'highcharts';
declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');


Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
@Component({
  selector: 'app-statistique',
  templateUrl: './statistique.component.html',
  styleUrls: ['./statistique.component.css']
})
export class StatistiqueComponent implements OnInit {

  itemmodel = [

  ];
  selectedModel:any={id:0};
  Highcharts = Highcharts;
  options:any;
  options1:any;
  options2:any;
  //For produits vendus
  dataBabs=[{}];
 TabLibelleProduits: any[] = [];
 TabQteVendusProduits: any[] = [];
 //For clients
 dataClients=[{}];
 TabNomClients: any[] = [];
 TabQteAchetes: any[] = [];
  constructor(   private produitservice: ProduitService,) { }

  ngOnInit() {
    this.getdixclient();
    this.dixproduitvendus();
    //this.nombreachat();
  }
  getdixclient(){
    this.produitservice.dixclient().subscribe(
      (data:any[])=>{
          console.log(data);
          for(let d of data.slice(0,7)){
            //console.log("ELEMENT",d[0]);
            this.TabNomClients.push(d[0]);
            this.TabQteAchetes.push(d[1]);
          }

          this.dataClients = [{
            name: 'Montant total achat',
            data: this.TabQteAchetes
         }];
        this.options2={
          chart: {
            type: "spline"
         },
         title: {
            text: "Les clients qui commandent le plus"
         },
         xAxis:{
            categories: this.TabNomClients
         },
         yAxis: {
            title:{
               text:"Somme"
            }
         },
         tooltip: {
          pointFormat: '{series.name}:<b>{point.y:,.0f}</b> FCFA'
         },
         series: this.dataClients

        };


      }
    )
  }

  dixproduitvendus(){

    this.produitservice.dixproduitvendus().subscribe(
      (data:any[])=>{
          console.log(data);
          for(let d of data.slice(0,7)){
            //console.log("ELEMENT",d[0]);
            this.TabLibelleProduits.push(d[0]);
            this.TabQteVendusProduits.push(d[1]);
          }

          this.dataBabs = [{
            name: 'Total vendus',
            data: this.TabQteVendusProduits
         }];
        this.options1={
          chart: {
            type: "bar"
         },
         title: {
            text: "Les produits les plus vendus"
         },
         xAxis:{
            categories: this.TabLibelleProduits
         },
         yAxis: {
            title:{
               text:"Quantité"
            }
         },
         tooltip: {
          pointFormat: '{series.name}:<b>{point.y:,.0f}</b> Articles'
         },
         series: this.dataBabs

        };


      }
    )
  }

  /*nombreachat(){

    this.produitservice.nombreachat().subscribe(
      (data:any)=>{
          console.log(data);
        this.options2={
          chart: {
            type: 'bar',
            background:'green'
          },
          title: {
            text: 'Classement des produits selon le nombre d\'achat '
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            title: {
              text: 'Le nombre d\'achat'
            }

          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },

          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: a effectué <b>{point.y}</b> achat(s)<br/>'
          },

          series: [{
            name: 'Commande',
            data: []
          }],

        };


        for (let a of data) {
          this.options2.xAxis.categories.push(a.nom);
          this.options2.series[0].data.push(a.nombre);
        }
      }
    )
  }*/
}
